const useReloadFreePopup = (props) => {
    const showFreeSignupPopup = (timesPopupShown) => {
        props?.setHidePopup && props.setHidePopup(false);
        sessionStorage.setItem("FreeSignUpPopupCount", timesPopupShown + 1);
        sessionStorage.setItem("FreeSignUpLastShown", new Date().getTime());
    }
    const getPopupFrequency = (timesPopupShown) => {
        switch (timesPopupShown) {
            case 1:
                return 60000;
            case 2:
                return 120000;
            case 3:
                return 240000;
            default:
                return 20000;
        }
    }

    const reloadFreePopup = () => {
        const timesPopupShown = parseInt(sessionStorage.getItem("FreeSignUpPopupCount")) || 0;
        const timePopupLastShown = parseInt(sessionStorage.getItem("FreeSignUpLastShown")) || 0;

        if (timesPopupShown < 4) {
            var now = new Date().getTime();
            var showNext = timePopupLastShown + getPopupFrequency();
            var diff = showNext - now;

            if (diff > 0) {
                setTimeout(() => {
                    showFreeSignupPopup(timesPopupShown);
                }, diff);
            } else if (diff < -getPopupFrequency(timesPopupShown)) {
                setTimeout(() => {
                    showFreeSignupPopup(timesPopupShown);
                }, 20000); // Show popup after 20 seconds
            }
        }
    };

    return reloadFreePopup;
};

export default useReloadFreePopup;
